'use client';

import type { ReactNode } from 'react';

import { X } from 'lucide-react';

import { Button } from '~/components/ui/button';
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '~/components/ui/sheet';
import { Trans } from '~/components/ui/trans';

export function ParcelSheet(props: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  /** Optional subtitle; without one the title also names the dialog for screen readers. */
  description?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Sheet open={props.open} onOpenChange={props.onOpenChange}>
      <SheetContent
        className="pw-sheet overflow-y-auto data-[side=right]:w-full data-[side=right]:sm:max-w-lg"
        showCloseButton={false}
      >
        <SheetHeader className="border-b px-7 pt-9 pr-14 pb-6">
          <SheetTitle className="text-xl font-semibold tracking-tight">{props.title}</SheetTitle>
          {props.description ? (
            <SheetDescription className="mt-2 leading-relaxed">
              {props.description}
            </SheetDescription>
          ) : (
            <SheetDescription className="sr-only">{props.title}</SheetDescription>
          )}
        </SheetHeader>
        <SheetClose
          data-test="parcel-sheet-close"
          render={<Button variant="ghost" size="icon-sm" className="absolute top-4 right-4" />}
        >
          <X className="size-4" />
          <span className="sr-only">
            <Trans i18nKey="parcelWatch.common.close" />
          </span>
        </SheetClose>
        <div className="px-7 pb-8">{props.children}</div>
      </SheetContent>
    </Sheet>
  );
}
